#import "~/graphql/fragments/contentBuilder/contentBlocks.graphql"
#import "~/graphql/fragments/seo/index.graphql"

fragment defaultSection on page_Entry {
    __typename
    id
    slug
    title
    contentBlocks {
        ... contentBlocks
    }
    seo {
        ... socialFragment
    }
}
